import PropTypes from 'prop-types';
import React from 'react';
import content from '../../locales/en/content.json';
import { getProfilePrefillRating } from '../../utils/helpers';
import PrefillConfirmationReview from './PrefillConfirmationReview';

const LABEL = content['sponsor--prefill-disability-review-label'];

const SponsorDisabilityPrefillReview = ({ formData, ...props }) => (
  <PrefillConfirmationReview
    {...props}
    rows={[{ label: LABEL, value: `${getProfilePrefillRating(formData)}%` }]}
  />
);

SponsorDisabilityPrefillReview.propTypes = {
  formData: PropTypes.object,
};

export default SponsorDisabilityPrefillReview;
